import React, {useEffect, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import Paper from "@material-ui/core/Paper";
import {useDispatch, useSelector} from "react-redux";
import {clearCurrentLatLng, setZipCode} from "../../core/redux/ActionCreator";
import {ZIP_ERROR} from "../../shared/constantsEN";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },
    input: {
        marginLeft: theme.spacing(0),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
}));

function LocationSearchBar() {
    const classes = useStyles();

    const searchBoxRef = React.createRef();
    const [zipCodeError, setZipCodeError] = useState(false);
    const zipcode = useSelector(state => state.yearMakeModelReducer.zipCode);
    const dispatch = useDispatch();

    const validateZipcode = (zip) => {
        let isValid;
        if (zip !== '' && zip.match(/^\b\d{5}(-\d{4})?\b$/)) {
            setZipCodeError(false);
            isValid = true;
        } else if (zip === 'empty' || zip === 'Current Location') {
            searchBoxRef.current.value = 'Current Location';
            setZipCodeError(false);
            isValid = true;
        } else {
            setZipCodeError(true);
            isValid = false;
        }
        return isValid;
    };

    const handleFormSubmit = (submitEvent) => {
        submitEvent.preventDefault();
        if (validateZipcode(searchBoxRef.current.value)) {
            let value = '';
            if (searchBoxRef.current.value !== 'Current Location') {
                value = searchBoxRef.current.value;
            }

            if (zipcode === '' && searchBoxRef.current.value === zipcode) {
                dispatch(clearCurrentLatLng());
                dispatch(setZipCode(value));
            } else if (searchBoxRef.current.value !== zipcode) {
                dispatch(setZipCode(value));
            }
        }
    };

    useEffect(() => {
        validateZipcode(zipcode);
        //eslint-disable-next-line
    }, [zipcode]);

    return (
        <>
            <Paper component="form" onSubmit={handleFormSubmit} >
                <TextField
                    variant="outlined"
                    className={`${classes.input} stat-search-input`}
                    data-dtm={"choose dealer"}
                    inputRef={searchBoxRef}
                    placeholder="ZIP Code"
                    aria-label={'search google maps'}
                    defaultValue={zipcode === 'empty' ? '' : zipcode}
                    inputProps={{'aria-label': 'search google maps', maxLength: 5}}
                    InputProps={{
                        startAdornment: (
                            <IconButton type="submit" className={`${classes.iconButton} stat-search-submit`}
                                        data-dtm={"choose dealer:zip code"} aria-label="search">
                                <SearchIcon/>
                            </IconButton>
                        ),
                    }}
                    error={zipCodeError}
                    helperText={ZIP_ERROR}
                />
            </Paper>
        </>
    )
}

export default LocationSearchBar
